import * as type from "./type";

export const getLinkManagementRequest = (data) => {
    return {
        type: type.GET_LINK_MANAGEMENT_REQUEST,
        payload: data
    };
};
export const getLinkManagementSuccess = (data) => {
    return {
        type: type.GET_LINK_MANAGEMENT_SUCCESS,
        payload: data
    };
};
export const changeLinkStatusRequest = (data) => {
    return {
        type: type.STATUS_LINK_CHANGE_REQUEST,
        payload: data
    };
};
export const changeLinkStatusSuccess = (data) => {
    return {
        type: type.STATUS_LINK_CHANGE_SUCCESS,
        payload: data
    };
};

export const addEditLinkManagementRequest = (data) => {
    return {
        type: type.ADD_LINK_REQUEST,
        payload: data
    };
};
export const  addEditLinkManagementSuccess = (data) => {
    return {
        type: type.ADD_LINK_SUCCESS,
        payload: data
    };
};